const AVAILABLE = 0;
const UNAVAILABLE = 1;
const TOBEAVAILABLE = 2;
const CONTACT = 3;
const NOTINUSE = 4;

const isContractable = vacant => {
  return vacant === AVAILABLE || vacant === TOBEAVAILABLE || vacant === CONTACT;
};

const showInFloorPlan = vacant => {
  return vacant === AVAILABLE;
};

export const data = {
  AVAILABLE,
  UNAVAILABLE,
  TOBEAVAILABLE,
  CONTACT,
  NOTINUSE,
  isContractable,
  showInFloorPlan,
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/vacant.js